import React from "react";
import "./LeaderAdvisorySection.css";
import dotpattern from "../../Assets/leadership/dot.png"

const LeaderAdvisorySectionimg = ({
  titleLine1 = "100K-1M low Cross",
  titleLine2 = "Functional Advisors",
  description = "Our advisory board includes seasoned experts in law, communications, strategy, and human capital who bring perspective, governance, and stability to our leadership table.",
  buttonText = "Meet the Team",
  onButtonClick
}) => {
  return (
    <div className="advisory-wrapper">
      <section className="advisory-section">
        <div className="advisory-left">
          
          <div className="advisory-title">
            <h3>Application<br />Process</h3>
          </div>
          <div className="vertical-line"></div>
        </div>
        <div className="advisory-right">
          <img src={dotpattern} alt="dotpattern" />
        </div>
      </section>
    </div>
  );
};

export default LeaderAdvisorySectionimg;

